import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Api } from './interface';
import { Form, Button } from 'react-bootstrap';
import { Download } from 'react-bootstrap-icons';
import { Hint } from './constants.js';
import { getDateTime, shortDate } from './date';
import { IsRole } from './validator';
import { bake } from './common';
import { toast } from 'react-toastify';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { shortDtm } from './date';
import { GEEK_TRAS } from './constants.js';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import List from './transactionHistory.js';
export default function TransactionDetails(props) {
  const [history, setHistory] = useState([]);
  const [shippingHistory, setShippingHistory] = useState([]);
  const [details, setDetails] = useState([]);
  const [summary, setSummary] = useState([]);

  const [canEdit, setCanEdit] = useState(false);

  const [list] = useState([
    'Current Owner',
    'New Owner',
    'Current Location',
    'Comments',
    'Total',
  ]);
  // The shippingFields state holds the fields related to shipping details
  // These fields are used to display and update shipping details in the transaction
  // If the transaction is a shipping transaction, these fields will be populated with the shipping details
  // If the transaction is not a shipping transaction, these fields will be empty
  // The fields are:
  const [shippingFields, setShippingFields] = useState([
    { Field: 'company', Label: 'Company', FieldMeta: 'CompanyName' },
    { Field: 'contact', Label: 'Contact Name', FieldMeta: 'ContactName' },
    { Field: 'email', Label: 'Contact Email', FieldMeta: 'Email' },
    { Field: 'address', Label: 'Address', FieldMeta: 'Address' },
    {
      Field: 'shippingNumber',
      Label: 'Shipping Number',
      FieldMeta: 'ShippingNumber',
    },
  ]);

  const [geekType] = useState(props.row['Geek Type']);
  const [itemCols, setItemCols] = useState([]);
  const [qtyCols, setQtyCols] = useState([]);
  const [tabValue, setTabValue] = useState('1');
  const [isShip] = useState(props.row.isShip);
  const handleTabChange = (event, newValue) => {
    // If the transaction is a shipping transaction, fetch the shipping details
    // and populate the shippingFields state with the shipping details
    if (newValue === '2') {
      Api({
        sp: 'getTransactionExternalData',
        json: {
          transactionId: parseInt(props.row['Transaction_DBID'], 10),
        },
      }).then((response) => {
        let newShippingFields = shippingFields;
        newShippingFields = newShippingFields.map((field) => {
          return {
            ...field,
            Value: response[0][field.FieldMeta],
          };
        });
        setShippingFields(newShippingFields);
      });

      Api({
        sp: 'getTransactionExternalHistory',
        json: {
          id: parseInt(props.row['Transaction_DBID'], 10),
        },
      }).then((response) => {
        response.forEach((r) => {
          r['Timestamp'] = shortDtm(r['Timestamp']);
        });
        setShippingHistory(response);
      });
    }
    setTabValue(newValue);
  };

  useEffect(() => {
    let user = bake({ key: 'user' });
    // Check if the user has the required roles to edit the transaction
    // If the user is an Admin, Material Storage, Material Manager, or the creator of the transaction,
    // they can edit the shipping detials of the completed Ship transaction
    setCanEdit(
      IsRole('Admin') ||
        IsRole('Material Storage') ||
        IsRole('Material Manager') ||
        (user && user['name'] === props.row['Created By'])
    );
    Api({
      sp: 'getTransactionHistory',
      json: { id: parseInt(props.row.Transaction_DBID) },
    }).then((response) => {
      response.forEach((r) => {
        r['Timestamp'] = shortDtm(r['Timestamp']);
      });
      setHistory(response);
    });
    Api({
      sp: 'getTransactionDetails',
      json: { id: parseInt(props.row.Transaction_DBID) },
    }).then((response) => {
      let qtyCols = [response[0]['Field'], 'Quantity'];
      let itemCols = [
        'Build ID',
        'Serial Number',
        'Status',
        'Current Owner',
        'Last Updated',
      ];
      if (geekType === 'PTO') {
        qtyCols.splice(1, 0, 'Box ID');
        itemCols.splice(1, 0, 'Box ID');
      }
      setQtyCols([...qtyCols]);
      setItemCols([...itemCols]);
      setDetails(response);
      setSummary(sumDetails(response));
    });
  }, []);

  // Returns the sum of quantity from the array of objects based on BuildID (for SSDs)/Component LotID(for Components)
  // And for Geek+ PTO transaction it returns the the sum of quantity by the combination of BuildID and BoxID
  const sumDetails = (inputs) => {
    return Object.values(
      inputs.reduce((a, { Field, FieldValue, Quantity, ['Box ID']: bid }) => {
        let key = `${Field}${FieldValue}`;
        if (geekType === 'PTO') {
          key = `${key}|${bid}`;
        }
        return {
          ...a,
          [key]: {
            Field,
            FieldValue,
            'Box ID': `${bid}`,
            Quantity: ((a[key] && a[key].Quantity) || 0) + Quantity,
          },
        };
        // eslint-disable-next-line prettier/prettier
      }, {})
    );
  };

  // Updates the shipping field value in the shippingFields state
  // This function is called when the user changes the value of a shipping field
  const updateShippingField = (val, updateField) => {
    let newShippingFields = shippingFields;
    newShippingFields = newShippingFields.map((field) => {
      return field.Field === updateField.Field
        ? { ...field, Value: val }
        : field;
    });
    setShippingFields(newShippingFields);
  };

  // Handles the change in shipping field value
  // This function is called OnBlur() of any of the shipping field
  // It validates the address field and updates the shippingFields state
  // It also makes an API call to update the transaction with the new shipping details
  const handleShippingFieldChange = (val, field) => {
    if (
      field.Field === 'address' &&
      (!field?.Value ||
        field?.Value === '' ||
        !field?.Value?.length ||
        field?.Value?.length < 5)
    ) {
      toast.error('Invalid Address');
      return;
    }

    let newShippingFields = shippingFields ?? {};
    newShippingFields = newShippingFields.map((shippingField) => {
      return shippingField.Field === field.Field
        ? { ...shippingField, Value: val }
        : shippingField;
    });
    setShippingFields(newShippingFields);
    let json = {
      transactionId: parseInt(props.row['Transaction_DBID'], 10),
    };
    newShippingFields.map((field) => {
      json[field.Field] = field.Value;
    });
    Api({ sp: 'updateTransaction', json: json }).then((response) => {
      toast.success(
        'Transaction ' +
          response[0]?.Transaction_DBID.toString().padStart(8, '0') +
          ' successfully updated'
      );
    });
  };

  const downloadDetailsCSV = () => {
    {
      let csvContent = 'Transaction,' + props.row.Transaction_DBID + ',';
      csvContent +=
        'Current Owner,' +
        String(props.row['Current Owner'] ?? '').replace(',', ' ') +
        '\n';
      csvContent += 'Current Location,' + props.row['Current Location'] + ',';
      csvContent +=
        'New Owner,' +
        String(props.row['New Owner'] ?? '').replace(',', ' ') +
        '\n';
      csvContent += '\n\n\n';

      csvContent += itemCols.join(',') + '\n';
      details.forEach((row) => {
        let csvRow = [
          row['FieldValue'],
          row['Serial Number'],
          row['Status'],
          row['Current Owner'],
          shortDate(row['Last Updated']),
        ];
        if (geekType == 'PTO') {
          csvRow.splice(1, 0, row['Box ID']);
        }
        csvContent += csvRow.join(',') + '\n';
      });
      var blob = new Blob([csvContent], {
        type: 'text/csv;charset=utf-8,',
      });

      // Programatically create a link and click it:
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      let fileName =
        'Transaction_Summary' + props.row.Transaction_DBID + getDateTime();
      a.download = `${fileName}.csv`;
      a.click();
    }
  };

  // Closes the modal and resets the shipping fields
  const closeModal = () => {
    setShippingFields();
    props.closeModal();
  };

  return (
    <Modal
      show={props.show}
      onHide={() => closeModal()}
      dialogClassName="modal-60w"
    >
      <Modal.Header closeButton="true">
        <Modal.Title>
          {GEEK_TRAS[geekType]} Transaction {props.row.Transaction_DBID}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TabContext value={tabValue}>
          <TabList onChange={handleTabChange} aria-label="basic tabs example">
            <Tab
              className={'details-tab' + (!isShip ? ' no-pointer' : '')}
              value="1"
              label="Transaction Details"
            />

            {isShip ? (
              <Tab className="details-tab" value="2" label="Shipping Details" />
            ) : (
              ''
            )}
          </TabList>
          <TabPanel value="1" className="muiTabPanelDetails">
            <div className="d-flex justify-content-between">
              <div className="modal-box">
                <h5>Summary</h5>
                <ul className="list-unstyled">
                  {list.map((l, i) => {
                    return (
                      <li key={i}>
                        <h6>{l}</h6>
                        <li className="mb-2">{props.row[l]}</li>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="detail-modal-box">
                {summary.length ? (
                  <div className="detail-modal-box">
                    <h5>Quantities</h5>
                    <div>
                      <Paper
                        sx={{ width: '100%' }}
                        className="transaction-detail-quantities"
                      >
                        <TableContainer
                          component={Paper}
                          className="tableContainer"
                          id="tab-container"
                        >
                          <Table stickyHeader aria-label="sticky table">
                            {/* Column Headers */}
                            <TableHead>
                              <TableRow>
                                {qtyCols.map((column, i) => (
                                  <TableCell
                                    key={i}
                                    align={'left'}
                                    padding={'normal'}
                                  >
                                    <span
                                      className={'col-header table-header pr-2'}
                                    >
                                      {column}
                                    </span>
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>

                            {/* Table Content */}
                            <TableBody>
                              {summary.map((detail, i) => {
                                return (
                                  <TableRow
                                    //   hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={i}
                                  >
                                    <TableCell align={'left'}>
                                      {detail['FieldValue']}
                                    </TableCell>
                                    {geekType === 'PTO' ? (
                                      <TableCell align={'left'}>
                                        {detail['Box ID']}
                                      </TableCell>
                                    ) : null}
                                    <TableCell align={'left'}>
                                      {detail['Quantity']}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Paper>
                    </div>
                  </div>
                ) : null}

                <br />
                {details.length && details[0]['Serial Number'] ? (
                  <div className="detail-modal-box">
                    <div className="item-header">
                      <h5>Items</h5>
                      <Hint
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        title="Export to Excel"
                      >
                        <Button
                          className="icon-btn"
                          type="radio"
                          variant="outline-primary"
                          onClick={() => downloadDetailsCSV()}
                        >
                          <Download className="export" size={20} />
                        </Button>
                      </Hint>
                    </div>

                    <div>
                      <Paper
                        sx={{ width: '100%' }}
                        className="transaction-detail-items"
                      >
                        <TableContainer
                          component={Paper}
                          className="tableContainer-items"
                          id="tab-container"
                        >
                          <Table stickyHeader aria-label="sticky table">
                            {/* Column Headers */}
                            <TableHead>
                              <TableRow>
                                {itemCols.map((column, i) => (
                                  <TableCell
                                    key={i}
                                    align={'left'}
                                    padding={'normal'}
                                  >
                                    <span
                                      className={'col-header table-header pr-2'}
                                    >
                                      {column}
                                    </span>
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>

                            {/* Table Content */}
                            <TableBody>
                              {details.map((detail, i) => {
                                return (
                                  <TableRow
                                    // hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={i}
                                  >
                                    <TableCell align={'left'}>
                                      {detail['FieldValue']}
                                    </TableCell>
                                    {geekType === 'PTO' ? (
                                      <TableCell align={'left'}>
                                        {detail['Box ID']}
                                      </TableCell>
                                    ) : (
                                      ''
                                    )}
                                    <TableCell align={'left'}>
                                      {detail['Serial Number']}
                                    </TableCell>
                                    <TableCell align={'left'}>
                                      {detail['Status']}
                                    </TableCell>
                                    <TableCell align={'left'}>
                                      {detail['Current Owner']}
                                    </TableCell>
                                    <TableCell align={'left'}>
                                      {shortDate(detail['Last Updated'])}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Paper>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <List list={history} title="History" id="1" />
          </TabPanel>
          <TabPanel value="2" className="muiTabPanelDetails">
            {/* If the transaction is a Ship transaction, display the shipping details */}
            {props.row?.isShip ? (
              <div className="modal-box">
                <h5>Shipping Details</h5>
                <ul className="list-unstyled">
                  {shippingFields.map((field, i) => {
                    return (
                      <div className="mb-2" key={i}>
                        <h6>{field.Label}</h6>
                        {/* If the user can edit the shipping details, display a textarea to edit the field value */}
                        {canEdit ? (
                          <Form.Control
                            className="w-100 overflow-hidden"
                            as="textarea"
                            rows="1"
                            onChange={(e) =>
                              updateShippingField(e.target.value, field)
                            }
                            onBlur={(e) => {
                              handleShippingFieldChange(e.target.value, field);
                            }}
                            value={field.Value || ''}
                          />
                        ) : (
                          <span>{field.Value || ''}</span>
                        )}
                      </div>
                    );
                  })}
                </ul>
              </div>
            ) : null}

            {/* If the transaction has external shipping history, display the shipping history details */}
            <List list={shippingHistory} title="History" id="2" />
          </TabPanel>
        </TabContext>
      </Modal.Body>
    </Modal>
  );
}
